<template>
    <div class="field display-inline-block"
         :class="{'is-error': isInvalid}"
         :style="styles">
        <input
            class="field-input field-input-inline"
            v-fs-block
            :value="value"
            :style="styles"
            @input="update"
            :placeholder="placeholder"
            :disabled="disabled"
            :type="type"
            @keyup.enter="keySubmit"
            @keyup="keyPress"
            @keydown="keyDown"
            @focus="focus"
            :name="name"
            :autocomplete="autocompleteFlag"/>
        <span class="field-caption" v-if="helpText">{{helpText}}</span>
    </div>
</template>
<script>
    import {RInput} from '@rebilly/recomponents';

    export default {
        name: 'v-inline-input',
        extends: RInput,
        computed: {
            styles() {
                return {
                    maxWidth: this.maxWidth || '',
                };
            },
        },
    };
</script>

<docs>
    Default
    ```vue
        <div>
            <v-inline-input />
        </div>
    ```
</docs>
